import createAxiosClient, { config } from "../utils/api-utils";

class ChatApi {
  constructor() {
    this.client = createAxiosClient();
  }

  /**
   * Get all conversations for the current user
   * GET /api/v1/chat/conversations
   */
  async getConversations() {
    return await this.client.get("/chat/conversations", config());
  }

  /**
   * Get message history for a specific conversation
   * GET /api/v1/chat/messages/{conversationId}
   * @param {string} conversationId - sorted "userId1#userId2"
   * @param {Object} params - optional { limit, before } for pagination
   */
  async getMessages(conversationId, params = {}) {
    return await this.client.get(`/chat/messages/${encodeURIComponent(conversationId)}`, {
      ...config(),
      params,
    });
  }

  /**
   * Count messages + unique senders received by the current user
   * GET /api/v1/chat/pending-summary
   */
  async getPendingSummary() {
    return await this.client.get('/chat/pending-summary', config());
  }

  /**
   * Check if a user is currently online (has an active WebSocket connection)
   * GET /api/v1/chat/presence/{userId}
   */
  async getPresence(userId) {
    return await this.client.get(`/chat/presence/${userId}`, config());
  }

  // Legacy compatibility shims (no-ops — functionality replaced by WebSocket + above)
  /** @deprecated messages are sent via WebSocket */
  async addMsg() { return { data: {} }; }
  /** @deprecated use getConversations() */
  async getChatList() { return this.getConversations(); }
  /** @deprecated use getMessages(conversationId) */
  async getMsgByUser() { return { data: [] }; }
}

export default ChatApi = new ChatApi();
